import { render, staticRenderFns } from "./contentCourseLiveCreate.vue?vue&type=template&id=817a9eac&"
import script from "./contentCourseLiveCreate.vue?vue&type=script&lang=js&"
export * from "./contentCourseLiveCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports